export const saveCashManagement = (data) => {
    console.log("im saving the data here", {data});

    let result = {};
}